module.exports = __webpack_public_path__ + "static/img/4-1.7d0927d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoology/4-1.png
// module id = T2NX
// module chunks = 15